//@ts-check

/** @type {import('../types').DataType<any>} */
var MICROSERVICE_DATA_TYPE = {
  data: {
    itemUrl: '/backend/microservices2?appId={id}',
    createItemUrl: '/backend/microservices2',
    dataKey: 'microservices',
    idKeyProp: 'MicroserviceAppInstallation.Id'
  },
  placeholders: {
    label: function label(data) {
      return data.MicroserviceAppInstallation.Name;
    },
    type: function type() {
      return 'app';
    },
    icon: function icon() {
      return 'app';
    },
    name: function name(data) {
      return data.MicroserviceAppInstallation.Name;
    }
  }
};
export default MICROSERVICE_DATA_TYPE;